 
import { LegalSection } from '@/components/LegalSection';

import type { ReactElement } from 'react';


const AvisoLegal = (): ReactElement => (
	<div className="p-legal">
		<article className="[ u-flow ]">
			<strong className="p-legal__tit">Aviso legal</strong>
			<LegalSection title="1. Información Legal">
				<p>
					El CONSEJO GENERAL DEL NOTARIADO es el titular de la Web https://www.empresa.portalnotarial.es (en adelante “el Sitio Web”), constituido bajo la forma legal de Corporación de Derecho Público, con domicilio en C/ Silvano, nº 55, 28043 Madrid, telf. 91-3087232, fax 91-3087053, CIF: Q2863008E
				</p>
			</LegalSection>
			<LegalSection title="2. Condiciones de uso y acceso">
				<div className='u-flow'>
					<p>
						El presente &quot;Aviso Legal&quot; regula el uso del servicio de la Sede Electrónica Notarial del CONSEJO GENERAL DEL NOTARIADO (en adelante, el &quot;Sitio Web&quot;) que pone a disposición de los Usuarios.
					</p>
					<p>
						La utilización del Sitio Web y de sus contenidos atribuye la condición de Usuario de la misma (en adelante, el ”Usuario”) e implica la aceptación de todas y cada una de las condiciones incluidas en el presente Aviso Legal, en la versión publicada en el momento en que se acceda al mismo. El Usuario se obliga a hacer un uso diligente del Sitio Web, de acuerdo con la Ley y el presente Aviso legal. El Usuario debe leer atentamente el presente Aviso Legal en cada una de las ocasiones en que se proponga utilizar el Sitio Web, puesto que las condiciones de uso podrán sufrir modificaciones. El acceso al Sitio Web es gratuito salvo en lo relativo al coste de la conexión a través de la red de telecomunicaciones suministrada por el proveedor de acceso contratado por el Usuario.
					</p>
					<p>
						El CONSEJO GENERAL DEL NOTARIADO se reserva el derecho a interrumpir en cualquier momento y sin previo aviso el acceso al Sitio Web, así como a interrumpir la prestación de cualquiera o de todos los servicios que se prestan a través del mismo, ya sea por motivos técnicos, de seguridad, de mantenimiento, por fallos en el de suministro eléctrico o por cualquier otra causa. Dicha interrupción podrá tener carácter temporal o definitivo.
					</p>
					<p>
						El CONSEJO GENERAL DEL NOTARIADO no garantiza la fiabilidad y disponibilidad de su Sitio Web, por lo que la utilización de los mismos por parte del Usuario se lleva a cabo por su propia cuenta y riesgo.
					</p>
					<p>
						El uso de la contraseña es personal e intransferible. El Usuario se compromete a hacer un uso diligente y a mantenerla en secreto, asumiendo toda responsabilidad por las consecuencias de su divulgación a terceros.
					</p>
				</div>
			</LegalSection>
			<LegalSection title="3. Objeto" >
				<p>
					El presente Sitio Web tiene por objeto dar a conocer a todos los Usuarios la información de los servicios ofrecidos por el Portal Notarial de Empresas y Profesionales del CONSEJO GENERAL DEL NOTARIADO, pudiéndose modificar en cualquier momento y sin previo aviso, el diseño, la presentación o la configuración del Sitio Web, así como sus contenidos
				</p>
			</LegalSection>
			<LegalSection title="4. Formularios de recogida de datos">
				<div className='u-flow'>
					<p>
						La utilización de ciertos servicios o solicitudes al CONSEJO GENERAL DEL NOTARIADO estarán condicionadas a la previa cumplimentación del correspondiente registro de Usuario mediante formularios.
					</p>
					<p>
						Toda la información que facilite el Usuario a través de los formularios del Sitio Web a los efectos anteriores o cualesquiera otros deberá ser veraz. A estos efectos, el Usuario garantiza la autenticidad de todos aquellos datos que comunique y mantendrá actualizada la información facilitada, siendo responsable de la información falsa o inexacta que realice y de los perjuicios que cause al CONSEJO GENERAL DEL NOTARIADO.
					</p>
				</div>
			</LegalSection>
			<LegalSection title="5. Introducción de enlaces al Sitio Web">
				<div>
					<p>
						El Usuario que introduzca enlaces desde sus propias páginas al Sitio Web deberá cumplir con las siguientes condiciones:
					</p>
					<ul className="[ o-list o-list--bullet ] [ u-mt-32 u-flow ]">
						<li>
							El enlace únicamente vinculará con la home page o página principal del
							Sitio Web pero no podrá reproducirla de ninguna forma (copia de los textos, gráficos, etc).
						</li>
						<li>
							Queda prohibido, de acuerdo con la legislación vigente en cada momento, establecer frames o
							marcos de cualquier tipo que envuelvan al Sitio Web o permitan la visualización de los
							contenidos a través de direcciones de Internet distintas a las del Sitio Web y, en cualquier
							caso, cuando se visualicen conjuntamente con contenidos ajenos al Sitio Web de forma que:
							<ul className="[ o-list o-list--bullet ] [ u-mt-16 ] ">
								<li>
									produzca, o pudiera producir, error, confusión o engaño en los Usuarios sobre la
									verdadera procedencia del servicio o contenidos.
								</li>
								<li>suponga un acto de comparación o imitación desleal.</li>
								<li>resulte prohibido por la legislación vigente.</li>
							</ul>
						</li>
						<li>
							El Sitio Web que inserte el enlace no podrá realizar ningún tipo de manifestación falsa,
							inexacta o incorrecta sobre el CONSEJO GENERAL DEL NOTARIADO, sus miembros, y en general del
							cuerpo notarial.
						</li>
						<li>
							En ningún caso se expresará en el Sitio Web donde se ubique el enlace que el CONSEJO GENERAL
							DEL NOTARIADO ha prestado su consentimiento para la inserción del enlace o que de otra forma
							patrocina, colabora o verifica los servicios del autor del enlace.
						</li>
						<li>
							El Sitio Web que establezca el enlace cumplirá con la ley y no podrá en ningún caso disponer
							o enlazar con contenidos propios o de terceros que:
							<ul className="[ o-list o-list--bullet ] [ u-mt-16 ] ">
								<li>
									sean ilícitos, nocivos o contrarios a la moral y a las buenas costumbres
									(pornográficos, violentos, racistas, etc.).
								</li>
								<li>
									induzcan o puedan inducir en el Usuario la falsa concepción de que el CONSEJO
									GENERAL DEL NOTARIADO suscribe, respalda, se adhiere o de cualquier manera apoya,
									las ideas, manifestaciones o expresiones, lícitas o ilícitas, del remitente.
								</li>
								<li>
									resulten inapropiados con la actividad del CONSEJO GENERAL DEL NOTARIADO en relación
									al lugar, contenidos y temática de la página web del remitente.
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</LegalSection>
			<LegalSection title="6. Propiedad Industrial e Intelectual">
				<div className='u-flow'>
					<p>
						Toda la información contenida en este Sitio Web así como el diseño gráfico, imágenes, códigos fuente, marcas, nombres comerciales, denominaciones, artículos, informes, etc…, están sujetos a los derechos de propiedad intelectual e industrial del CONSEJO GENERAL DEL NOTARIADO o de terceros.
					</p>
					<p>
						Bajo ningún supuesto, el acceso al Sitio Web supone la renuncia, transmisión, cesión o licencia total o parcial de dichos derechos de propiedad intelectual o industrial, ni confiere ningún derecho de utilización, traducción, adaptación, alteración, explotación, reproducción, distribución o comunicación pública, con fines comerciales, de dichos contenidos sin la previa y expresa autorización del CONSEJO GENERAL DEL NOTARIADO o del tercero titular de los derechos afectados. Quedan a salvo los derechos del Usuario de visualizar y obtener una copia en la memoria caché del ordenador del Usuario, como reproducción transitoria y accesoria, sin que en ningún caso esté autorizado para comunicar la misma a terceros.
					</p>
					<p>
						La infracción de cualquiera de los citados derechos puede constituir una vulneración de las presentes disposiciones, así como un delito castigado de acuerdo con los artículos 270 y siguientes del Código Penal.
					</p>

				</div>
			</LegalSection>
			<LegalSection title="7. Responsabilidad">
				<div className='u-flow'>
					<p>
						El CONSEJO GENERAL DEL NOTARIADO no será responsable en caso de que existan interrupciones del
						servicio, demoras, errores o mal funcionamiento de dicho servicio que tengan su origen en causas
						ajenas a la misma o debidas a una actuación dolosa o culposa del Usuario, o a causa de fuerza
						mayor. Son causas de fuerza mayor fallos de terceros, operadores o compañías de servicios, falta
						de acceso a redes de terceros, actos u omisiones de las autoridades públicas, actos producidos
						como consecuencia de fenómenos naturales, apagones, etc…, y el ataque de hackers o terceros
						especializados a la seguridad o integridad del sistema informático, siempre que el CONSEJO
						GENERAL DEL NOTARIADO haya adoptado todas las medidas de seguridad existentes de acuerdo con el
						estado de la técnica.
					</p>
					<p>
						En cualquier caso, sea cual fuere su causa, el CONSEJO GENERAL DEL NOTARIADO no asumirá
						responsabilidad alguna ya sea por daños directos o indirectos, daño emergente y/o por lucro
						cesante.
					</p>
					<p>
						El CONSEJO GENERAL DEL NOTARIADO no se responsabiliza de contenidos y opiniones de terceros
						vertidos en su Sitio Web ni de la información contenida en las páginas Web de terceros a las que
						se pueda acceder por enlaces o buscadores del Sitio Web, puesto que la función de éstas es
						informar al Usuario sobre la existencia de otras fuentes de información sobre la materia en
						Internet, donde podrá ampliar los datos ofrecidos en este Sitio Web. Por todo ello, el CONSEJO
						GENERAL DEL NOTARIADO no será responsable del resultado obtenido a través de dichos enlaces
						hipertextuales.
					</p>
					<p>
						Cuando pueda accederse a páginas Web de terceros a través de buscadores o enlaces, el CONSEJO
						GENERAL DEL NOTARIADO actúa como prestador de servicios de intermediación de conformidad con el
						artículo 17 de la Ley 32/2002, de 12 de julio, de Servicios de la Sociedad de la Información y
						el Comercio Electrónico y sólo será responsable de los contenidos y servicios suministrados en
						los sitios enlazados en la medida en que tenga conocimiento efectivo de la ilicitud y no haya
						desactivado el enlace con la diligencia debida.
					</p>
					<p>
						En ningún caso la existencia de sitios enlazados debe presuponer la existencia de acuerdos con
						los responsables o titulares de los mismos, ni la recomendación, promoción o identificación del
						CONSEJO GENERAL DEL NOTARIADO con las manifestaciones, contenidos o servicios proveídos. El
						CONSEJO GENERAL DEL NOTARIADO no conoce los contenidos y servicios de los sitios enlazados y por
						tanto no se hace responsable por los daños producidos por la ilicitud, calidad,
						desactualización, indisponibilidad, error e inutilidad de los contenidos y/o servicios de los
						sitios enlazados ni por cualquier otro daño que no sea directamente imputable al CONSEJO GENERAL
						DEL NOTARIADO.
					</p>
					<p>
						El CONSEJO GENERAL DEL NOTARIADO no se hace responsable por la utilización que el Usuario
						realice de los servicios del Sitio Web ni de sus contraseñas, así como de cualquier otro
						material del Sitio Web, infringiendo los derechos de propiedad intelectual o industrial o
						cualquier otro derecho de terceros. El CONSEJO GENERAL DEL NOTARIADO no se hace responsable por
						los daños que puedan causarse en los equipos de los Usuarios por posibles virus informáticos
						contraídos por el Usuario a causa de su navegación en el Sitio Web, o por cualesquiera otros
						daños derivados de esa navegación. Corresponde al Usuario, en todo caso, disponer de
						herramientas adecuadas para la detección y desinfección de programas informáticos dañinos.
					</p>
					<p>
						El CONSEJO GENERAL DEL NOTARIADO no ofrece ninguna garantía de ausencia de errores en ninguno de
						los contenidos de su Sitio Web, además de no garantizar la corrección de cualquier defecto o la
						ausencia de virus y demás componentes dañinos en el presente Sitio Web o en su Servidor.
					</p>
					<p>
						El Usuario responderá frente al CONSEJO GENERAL DEL NOTARIADO de cualesquiera daños y perjuicios
						que pudieran causarse como consecuencia del incumplimiento de las condiciones de uso del Sitio
						Web y demás obligaciones establecidas en el presente Aviso Legal.
					</p>
				</div>
			</LegalSection>
			<LegalSection title="8. Publicidad">
				<p>
					Determinadas partes del Sitio Web pueden albergar contenidos publicitarios o estar patrocinados.
					Los anunciantes y patrocinadores son los únicos responsables de asegurarse que el material
					remitido para su inclusión en el Sitio Web cumple con las leyes que en cada caso puedan ser de
					aplicación.
				</p>
			</LegalSection>
			<LegalSection title="9. Ley aplicable y jurisdicción">
				<p>
					Para toda cuestión litigiosa o que incumba al Sitio Web rige la legislación española siendo
					competentes para la resolución de todos los conflictos derivados o relacionados con el uso del
					presente Sitio Web, los Juzgados y Tribunales de Madrid capital.
				</p>
			</LegalSection>
		</article>
	</div >
);

export default AvisoLegal;
